import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import { SubBannerSkeleton } from './Banner';

const DynamicSubBanner = dynamic(() => import('./Banner'), {
  ssr: false,
  loading: () => <SubBannerSkeleton />
});

const Banner = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <SubBannerSkeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicSubBanner skeleton={skeleton} {...props} />;
};

export default Banner;
